"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useGetKeyByActivityId = _interopRequireDefault(require("../providers/ActivityKeyer/useGetKeyByActivityId"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _useGetKeyByActivityId.default;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VHZXRLZXlCeUFjdGl2aXR5SWQiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VHZXRLZXlCeUFjdGl2aXR5SWQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZUdldEtleUJ5QWN0aXZpdHlJZCBmcm9tICcuLi9wcm92aWRlcnMvQWN0aXZpdHlLZXllci91c2VHZXRLZXlCeUFjdGl2aXR5SWQnO1xuXG5leHBvcnQgZGVmYXVsdCB1c2VHZXRLZXlCeUFjdGl2aXR5SWQ7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztlQUVlQSw4QiJ9